import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { getSemester, getAllDepartments } from '../common/utils';

import MainPage from './MainPage'
import SearchPage from './SearchPage'
import CoursePage from './CoursePage'
import InstructorPage from './InstructorPage'
// import logo from '../images/logo.svg';
import '../styles/App.css';

class App extends Component {
    getFooter() {
        return (
            <div className="app-footer">
                <div className="footer-section">Website created by Alexander Tse</div>
                <span>Contact: <a href="mailto:tse@cs.wisc.edu">tse@cs.wisc.edu</a> | </span>
                <span>Updated: { getSemester(getAllDepartments().lastUpdated) }</span>
                <div className="footer-section">Data collected from <a href="https://registrar.wisc.edu">UW-Madison's Registrar Office</a></div>
                <span>Feedback is welcome!</span>
            </div>
        )
    }

    render() {
        return (
            <div className="app-style">
                <BrowserRouter>
                    <div className="app-body">
                        <Route exact path="/" component={MainPage} />
                        <Route path="/search/:query" component={SearchPage} />
                        <Route path="/course/:courseId/:selectedEidHash?/:selectedTerm?" component={CoursePage} />
                        <Route path="/instructor/:eidHash" component={InstructorPage} />
                    </div>
                </BrowserRouter>
                { this.getFooter() }
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js